import React from 'react';
import TabLinkUI from '../../../widgets/output/TabLinkUI';

const MessageApprovalListNavUI = ({ context, page, account }) => {
  if (!account) {
    return <div className='g_m_top_50' />;
  }

  return (
    <div>
      <div className='g_flex_h g_flex_left g_flex_wrap'>
        <TabLinkUI
          label='Notice'
          to={`/su/accounts/${account.accountId}/messageApprovals`}
          active={page === 'messageApprovals'}
        />
        <TabLinkUI
          label='Whatsapp Message'
          to={`/su/accounts/${account.accountId}/messageApprovals/whatsapp`}
          active={page === 'messageApprovals_whatsapp'}
        />
        <TabLinkUI
          label='Email Message'
          to={`/su/accounts/${account.accountId}/messageApprovals/email`}
          active={page === 'messageApprovals_email'}
        />
      </div>
      <div className='g_m_top_50' />
    </div>
  );
};

export default MessageApprovalListNavUI;